import $ from "jquery";
import PubSub from "Utils/pub-sub";
import BreakpointDispatcher from "Utils/breakpoint-dispatcher";
import SmoothScroll from "Utils/smoothScroll";

const MOBILE_HEADER_HEIGHT = 50;
const MOBILE_TOC_PAD = 0;

const SELECTORS = {
    TOC_WRAPPER: ".js-toc_links-wrapper",
    TOC_LIST: ".js-toc_list",
    TOC_ITEM: ".js-toc_item",
    TOC_ARTICLE: ".js-toc_ref",
    TOC_SUMMARY: ".dcw_article-template_wrapper"
}

const CLASS = {
    IS_ACTIVE: ".is-active"
}

export default class TableOfContent {
        constructor(el) {
        BreakpointDispatcher.start();

        this.el = el;
        this.list = el.find(SELECTORS.TOC_LIST);
        this.linksNode = el.find(SELECTORS.TOC_WRAPPER);
        this.$articles = $(SELECTORS.TOC_ARTICLE);

        this.buildListFromArticles(this.$articles);

        this.$summaryWrapper = $(SELECTORS.TOC_SUMMARY);
        this.$items = el.find(SELECTORS.TOC_ITEM);

        this.setActiveItemFromHash();
        this.$lastActive = this.$items.filter(CLASS.IS_ACTIVE);
        this.isListOpen = false;
        this.handleClick = null;

        window.addEventListener("load", () => {
            this.originalScroll = window.scrollY;
            this.offsets = this.getOffsetTopOf(this.$articles);
        });

        this.init();
    }

    init() {
        switch (BreakpointDispatcher.getState()) {
            case BreakpointDispatcher.breakpoint.DESKTOP:
                this.handleDesktop();
                break;
            case BreakpointDispatcher.breakpoint.MOBILE:
                this.handleMobile();
                break;
        }
    }

    buildListFromArticles(articles) {
        var htmlListItems = "";

        [].forEach.call(articles, (article, i) => {
            htmlListItems = htmlListItems + this.renderListItem(article);
        });

        this.linksNode.html(htmlListItems);
    }

    renderListItem(article) {
        var articleId = article.id,
            articleTitle = $(article)
                .find(".js-toc_ref-title")
                .text();

        return `<li class='dcw_table-of-content_item js-toc_item'>
              <a class='dcw_table-of-content_anchor js-toc_link' href='#${articleId}'>${articleTitle}</a>
            </li>`;
    }

    getOffsetTopOf($items) {
        let offsets = [];
        $items.each((i, item) => {
            offsets.push(
                item.getBoundingClientRect().top - MOBILE_HEADER_HEIGHT - MOBILE_TOC_PAD
            );
        });
        return offsets;
    }

    setActiveItemFromHash() {
        let urlHash = window.location.hash;
        if (urlHash === "" || urlHash === "#") {
            this.$items
                .eq(0)
                .addClass("is-active")
                .find("a")
                .attr("aria-current", true);
        } else {
            this.$items
                .find("a")
                .filter('[href="' + urlHash.replace(/^#_/, "#") + '"]')
                .parent()
                .addClass("is-active")
                .find("a")
                .attr("aria-current", true);
        }
    }

    handleDesktop() {
        let self = this;

        this.bindResizes(self);

        this.handleClick = this.handleDesktopClick;
        this.$items.click(event => this.handleClick(event));
    }

    handleMobile() {
        let self = this;

        this.bindResizes(self);

        this.handleClick = this.handleMobileClick;
        this.$items.click(event => this.handleClick(event));
    }

    bindResizes(self) {
        PubSub.subscribe("resize:mobile", function() {
            self.handleClick = self.handleMobileClick;
        });

        PubSub.subscribe("resize:desktop", function() {
            self.handleClick = self.handleDesktopClick;
        });
    }

    handleDesktopClick(event) {
        let element = this.getListItem(event.originalEvent.target);
        let offset = this.$articles.eq(this.$items.index(element)).offset().top;

        SmoothScroll.scrollTo(offset, () => {
            this.updateAnchor(element);
        });

        this.updateActiveItem(element);
    }

    handleMobileClick(event) {
        let $element = $(event.originalEvent.currentTarget);
        this.toggleList();
        this.updateActiveItem($element);

        let offset = this.getComputedOffsetOf(this.offsets[this.$items.index($element)]);

        if (this.isListOpen) {
            SmoothScroll.scrollTo(offset, () => this.updateAnchor($element));
        }

        this.isListOpen = !this.isListOpen;
    }

    getComputedOffsetOf(value) {
        return this.originalScroll > 10 ?
            value + this.originalScroll - this.$summaryWrapper.outerHeight() :
            value - this.$summaryWrapper.outerHeight() * 2;
    }

    toggleList() {
        this.list.toggleClass("is-opened");
    }

    updateActiveItem(element) {
        let $lastActiveLink = this.$lastActive.find("a");
        let newActiveLink = element.find("a");

        this.$lastActive.removeClass("is-active");
        $lastActiveLink.attr("aria-current", false);
        element.addClass("is-active");
        newActiveLink.attr("aria-current", true);

        this.$lastActive = $(element);
    }

    getListItem(element) {
        return element.tagName !== "A" ? $(element) : $(element).parent();
    }

    getIndexOf(element, list) {
        return list.indexOf(element);
    }

    updateAnchor(element) {
        window.location.hash =
            "_" +
            element
                .find("a")
                .attr("href")
                .slice(1);
    }

    getHeaderHeight() {
        return $(".dcw_header").outerHeight() + this.getSubMenuNavHeight() + 32;
    }

    getSubMenuNavHeight() {
        var subMenuHeight = 0;

        if ($(".dcw_submenu-auth").length) {
            subMenuHeight = $(".dcw_submenu-auth").outerHeight();
        } else if ($(".dcw_submenu").length) {
            subMenuHeight = $(".dcw_submenu").outerHeight();
        }

        return subMenuHeight;
    }
}



// WEBPACK FOOTER //
// ./src/components/table-of-content/table-of-content.js